import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PackageEntity } from '../../domain/entities/PackageEntity'
import type { PackageAdminDto } from '@/backend/market'
export class PackageModel extends PackageEntity {
  constructor(dataDto: PackageAdminDto) {
    super()
    mapEntityProperties<PackageEntity>(this, dataDto, {
      map: {
        vehicleTemplateType: dataDto.vehicleTemplateType
      }
    })
  }
}
